import { createMongoAbility, AbilityBuilder } from "@casl/ability";

const { build } = new AbilityBuilder(createMongoAbility);

export const ability = build();
